import React from "react";
import Header from "../partials/Header";
import Footer from "../partials/Footer";
import "../App.css";

function Home() {
  return (
    <div className="home">
      <Header />

      <main>
        <div className="hero">
          <div className="hero_bg">
            <div className="hero-title-container"></div>
          </div>
        </div>

        <section className="slogan-section">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="slogan-container">
                  <div className="slogan-title-container">
                    <h1>
                      ONE-STOP DESTINATION
                      <br />
                      FOR ALL EVENTS
                    </h1>
                    <p>
                      We take care of everything from planning to execution.
                    </p>
                    <br />

                    <p className="title-des">
                      Whether it's a corporate event, wedding, or private party,
                      REMC has got you covered. Our team of experts ensures that
                      every detail is meticulously planned and executed to
                      create an unforgettable experience for you and your
                      guests.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="image-container">
                  <div className="review-popup d-flex">
                    <div style={{ marginRight: "10px" }}>
                      <h2 className="emoji" style={{ margin: "0px" }}>
                        <span>⭐</span>
                      </h2>
                    </div>
                    <div className="review-popup-des">
                      <p className="five-star">5 Star</p>
                      <p>The best event planer!</p>
                    </div>
                  </div>
                  <img
                    className="img-fluid"
                    src="https://www.eventbookings.com/wp-content/uploads/2018/03/event-ideas-for-party-eventbookings.jpg"
                    alt="Event Planning"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="services-section">
          <h1>WHAT WE DO</h1>
          <br />
          <div className="container">
            <div className="row" style={{ width: "100%" }}>
              <div className="col-12 col-md-4">
                <div className="service-card">
                  <h1>
                    <span className="emoji">🎉</span>
                  </h1>

                  <h3>Event Planning</h3>
                  <p>
                    Comprehensive planning services for all types of events,
                    ensuring every detail is perfect.
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="service-card">
                  <h1>
                    <span className="emoji">🎊</span>
                  </h1>
                  <h3>Venue Selection</h3>
                  <p>
                    Assistance in selecting the perfect venue that fits your
                    event needs and budget.
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="service-card">
                  <h1>
                    <span className="emoji">🍽️</span>
                  </h1>
                  <h3>Catering Services</h3>
                  <p>
                    Customized catering options to suit your event's theme and
                    dietary requirements.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="services-section">
          <h1>Trending Parties</h1>
          <br />
          <div className="container">
            <div className="parties-section">
              <div className="col-12 row">
                <div className="party-lg col-lg-7 col-md-12">
                  <img
                    className="img-fluid"
                    src="foodfest.png"
                    alt="Foodfest"
                  />
                  <div className="heading">
                    <h1>Food Festival</h1>
                  </div>
                </div>

                <div className="party-md col-lg-5 col-md-12">
                  <div className="party">
                    <img
                      className="img-fluid"
                      src="hiking.png"
                      alt="Hiking event"
                    />
                    <div className="heading">
                      <h1>Hiking Event</h1>
                    </div>
                  </div>

                  <div className="party">
                    <img
                      className="img-fluid"
                      src="party.png"
                      alt="Party room"
                    />

                    <div className="heading">
                      <h1>Party Room</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section className="services-section send-message-container">
          <h1>SEND US A MESSAGE!</h1>
          <br />
          <p className="text-center">
            Your journey to a perfect event starts here. <br />
            Whether you have a specific event in mind, our team is ready to
            assist you.
          </p>

          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="contact-form-container">
                  <form>
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        placeholder="Full Name"
                      />
                    </div>
                    <br />
                    <div className="mb-3">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="Email"
                      />
                    </div>
                    <br />
                    <div className="mb-3">
                      <label htmlFor="message" className="form-label">
                        Message
                      </label>
                      <textarea
                        className="form-control"
                        id="message"
                        rows="3"
                        placeholder="Your message here..."
                      ></textarea>
                    </div>
                    <button type="submit" className="btn btn-primary send">
                      SUBMIT
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section> */}
      </main>

      <Footer />
    </div>
  );
}

export default Home;
